import React, { useEffect } from "react";

export default function Disclaimers() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="max-w-4xl mx-auto p-6">
      <h1 className="text-3xl font-bold mb-6 text-center text-indigo-700 drop-shadow-md tracking-wide">
        Disclaimers
      </h1>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">1. Generic Disclaimers</h2>
        <p>
          The information provided on this website is for general informational purposes only and does not constitute legal, financial, or professional advice.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">2. Logo Use</h2>
        <p>
          All logos and trademarks displayed on this site are the property of their respective owners. They are used solely for identification and descriptive purposes.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">3. Trademarks and Symbols</h2>
        <p>
          The TM and ® symbols indicate trademarks registered or owned by their respective companies. Any unauthorized use of these trademarks is prohibited.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">4. Content Accuracy</h2>
        <p>
          We strive to provide accurate, up-to-date deal information. However, we do not guarantee the completeness, reliability, or accuracy of any listing. Prices, availability, and deals may change without notice, and occasional errors may occur.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">5. Affiliate Disclosure</h2>
        <p>
          Some links on this website may be affiliate links. If you make a purchase through an affiliate link, we may earn a small commission at no additional cost to you. These commissions help support the operation and maintenance of this site.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">6. User Responsibility</h2>
        <p>
          Users are responsible for verifying the validity, availability, pricing, and terms of any offer before making a purchase. We are not liable for any decisions, losses, or damages resulting from reliance on information found on this website.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">7. Product Safety & Liability</h2>
        <p>
          We do not manufacture, sell, or ship any products listed on this site. Product questions, safety concerns, defects, or issues should be directed to the original retailer or manufacturer. We assume no liability for damages or injuries related to the use or misuse of products listed here.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">8. Availability & Expiry</h2>
        <p>
          All deals are subject to availability and may expire or change at any time. We do not guarantee that any item will be in stock or available at the listed price. Users should verify pricing and availability directly with the retailer.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">9. Third-Party Content</h2>
        <p>
          This site may contain third-party content such as product descriptions, images, and links. We do not control or endorse third-party websites and are not responsible for their accuracy, content, or actions. Accessing third-party content is at the user's own risk.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">10. Images & Media</h2>
        <p>
          Images and media shown on this website are for illustration and informational purposes only. Some images may be sourced from retailer or manufacturer websites. Actual product appearance, colors, and packaging may vary. We do not claim ownership of product images unless explicitly stated.
        </p>
      </section>
    </div>
  );
}
